import React from 'react';
import AnnouncerContext from './AnnouncerContext';

var LiveMessenger = function LiveMessenger(_ref) {
  var children = _ref.children;
  return React.createElement(AnnouncerContext.Consumer, null, function (contextProps) {
    return children(contextProps);
  });
};

export default LiveMessenger;